import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {Button} from '@stubhub/bamboo';

class CheckoutButton extends React.PureComponent {
  static contextTypes = {
    router: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.handleClick.bind(this);
  }

  handleClick = (event) => {
    const {checkoutParamsString, onClick} = this.props;
    onClick && onClick(event);
    // TODO: this is a hack for now as i can't get context to work properly here
    window.location = `/buy/review?${checkoutParamsString}`;
  };

  render() {
    return (
      <Button {...this.props} onClick={this.handleClick}>
        <FormattedMessage id="SeatMapToolTip.checkoutText" defaultMessage="Checkout" />
      </Button>
    );
  }
}

CheckoutButton.propTypes = {
  /** The checkout parameters string. */
  checkoutParamsString: PropTypes.string.isRequired,

  /** The function to be called when the button is clicked. */
  onClick: PropTypes.func,
};

export default CheckoutButton;
